<template>
  <main class="main" role="main">
    <div class="page">
      <div class="inner">
        <div class="lnb">
          <ul>
            <li><p class="home"></p></li>
            <li><p>외식 경영 관리사</p></li>
            <li><p>시험 신청</p></li>
            <li><p>시험 신청</p></li>
          </ul>
        </div>
        <div class="page_ttl">
          <h1 class="h1">
            <span>시험 신청 완료</span>
          </h1>
        </div>
        <div class="page_con">
          <div class="complete tb_line">
            <div>
              <span class="big bold"
                >외식 경영 관리사 시험 신청이 완료되었습니다.</span
              >
              <div class="inform_box center mt40">
                <div>
                  아래의 정보로 교육비 입금 바랍니다.<br />
                  <ol class="dot">
                    <li class="small grey">
                      <span class="ol_li_txt">
                        계좌:
                        <span class="color bold"
                          >농협 355-0066-4272-33 ｜ (사)한국외식산업협회</span
                        >
                      </span>
                    </li>
                    <li class="small grey">
                      <span class="ol_li_txt">
                        응시료:
                        <span class="color bold">50,000원(교재비 포함)</span>
                      </span>
                    </li>
                  </ol>
                  <br />
                  <span class="color small"
                    >※ 입금내역은 접수 확인 및 취소페이지에서 확인할 수
                    있습니다.</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="page_btn">
          <button
            class="btn"
            @click="$router.push({ path: '/manager/exam/register' })"
          >
            목록으로
          </button>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'manage-exam-apply-done-index'
}
</script>

<style scoped></style>
